import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import YearlyWrite from './YearlyWrite';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grey from '@material-ui/core/colors/grey';
import { makeStyles } from '@material-ui/core/styles';
import DoneIcon from '@material-ui/icons/Done';
import CloseIcon from '@material-ui/icons/Close';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _each from 'lodash/each';
import moment from 'moment';

import dragIcon from '../../content/dragIcon.png';

const useStyles = makeStyles((theme) => ({
    accordion: {
        marginLeft: "-20px !important",
        marginRight: "-20px !important",
        margin: "0px auto", 
    },
    accordionSummary: {
        backgroundColor : theme.palette.info.light,
        margin: "0px auto",
    },
    table: {
        backgroundColor: Grey[200],
        marginTop: theme.spacing(.5),
    },
    tableRow: {
        verticalAlign: 'middle',
        '&:nth-of-type(even)': {
            backgroundColor: Grey[200],
        },
        '&:nth-of-type(odd)': {
            backgroundColor: '#fff',
        },
    },
    tableContainer: {
        width: '100%',
    },
    unavSlots: {
        fontSize: '90%',
        marginTop: '0',
        marginBottom: '0',
    },
}));

function VacationInformation({vacation, vacationNumber, isUpdating, freezeBidding, daysToBid, handleYearlyVacAdd, handleYearlyVacRemove, slotsAvailable, handleYearlyVacReorder }) {
    const classes = useStyles();

    const [vacBids, updateVacBids] = useState(vacation);
    useEffect(() => { updateVacBids(vacation)}, [vacation]);

    function handleOnDragEnd (result){ 
        if (!result.destination) return;
        const items = vacBids;
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);

        items.forEach((item, index) =>{
            item.rank = index + 1;
        });

        updateVacBids(items);
        handleYearlyVacReorder(vacBids, vacationNumber);
    };

    const availability = {};

    vacation.forEach(item =>{
        let unavDates = [];
        var slots = _filter(slotsAvailable, function(o) {
            return moment(o.slotDate).format() >= moment(item.startDate).format() && moment(o.slotDate).format() <= moment(item.inclusiveEndDate).format();
        });
        _each(slots, function(o) {
            if (o.availSlotsForDay < 1) {
                let date = new Date(o.slotDate);
                let unavDate = (date.getMonth() + 1) + '/' + date.getDate();
                unavDates.push(unavDate);
            }
        });
        availability[item.id] = unavDates;
    });


    return (
        <Accordion className={classes.accordion}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accordionSummary}>
                <Typography variant="h6">Vacation {vacationNumber}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.tableContainer}>
                        <TableContainer component={Paper}>
                            {vacation.length !== 0 && (
                                <Table size="small" className={classes.table}>
                                    <DragDropContext onDragEnd={handleOnDragEnd}>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell></TableCell>
                                                <TableCell>Rank</TableCell>
                                                <TableCell>Start Date</TableCell>
                                                <TableCell>Inclusive End Date</TableCell>
                                                <TableCell>Number of Days</TableCell>
                                                <TableCell>Submitted Date</TableCell>
                                                <TableCell>Slots availability</TableCell>
                                                <TableCell />
                                            </TableRow>
                                        </TableHead>
                                            <Droppable droppableId={vacationNumber.toString()}>
                                                {(provided) =>(
                                                    <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                                                        {vacation && _map(vacation, (i, index) => (
                                                        <Draggable key={i.id} draggableId={ (i.id.toString() !== '') ? i.id.toString() : vacation.length.toString()} index={index}>
                                                            {(provided) =>(
                                                                <TableRow key={i.id} className={classes.tableRow} {...provided.draggableProps} {...provided.dragHandleProps} ref={provided.innerRef}>
                                                                    <TableCell align="left"><img src={dragIcon} alt="Drag Icon" style={{height: "17px"}} /></TableCell>
                                                                    <TableCell align="left">{i.rank}</TableCell>
                                                                    <TableCell align="left">{i.startDate}</TableCell>
                                                                    <TableCell align="left">{i.inclusiveEndDate}</TableCell>
                                                                    <TableCell align="left">{i.numOfVacDays}</TableCell>
                                                                    <TableCell align="left">{i.bidSubmittedTime}</TableCell>
                                                                    <TableCell>{availability[i.id].length === 0 ? (
                                                                        <>
                                                                        <DoneIcon style={{ color:  "#4caf50"}}/><sup> Slots Available</sup>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                        <CloseIcon style={{ color:  "#f44336"}}/><sup> Slots Not Available</sup>
                                                                        <p className={classes.unavSlots}>Unavailable slots: {availability[i.id].join(', ')}</p>
                                                                        </>
                                                                    )}</TableCell>
                                                                    <TableCell align="left">
                                                                        {!freezeBidding && 
                                                                        <Button
                                                                            variant="outlined"
                                                                            color="primary"
                                                                            margin="dense"
                                                                            onClick={() => { handleYearlyVacRemove(i.id, vacationNumber); }}
                                                                        >
                                                                            Remove
                                                                        </Button>}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )}
                                                        </Draggable>
                                                        ))}
                                                        {provided.placeholder}
                                                    </TableBody>
                                                )}
                                            </Droppable>
                                    </DragDropContext>
                                </Table>
                            )}
                        </TableContainer>
                    </Grid>
                    {!freezeBidding && 
                    <Grid item md={12}>
                        <YearlyWrite
                            onYearlyVacAdd={handleYearlyVacAdd}
                            isUpdating={isUpdating}
                            vacationNumber={vacationNumber}
                            daysToBid={daysToBid}
                            slotsAvailable={slotsAvailable}
                        />
                    </Grid>}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

VacationInformation.propTypes = {
    vacation: PropTypes.array.isRequired,
    vacationNumber: PropTypes.number.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    daysToBid: PropTypes.number.isRequired,
    handleYearlyVacAdd: PropTypes.func.isRequired,
    handleYearlyVacRemove: PropTypes.func.isRequired,
    handleYearlyVacReorder: PropTypes.func.isRequired
};

export default VacationInformation;
